import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const AVISO_VERSION = 2;
const ROLES_GESTORES = ['ADMIN', 'DIRECTOR', 'GERENTE', 'SUPERVISOR'];

export default function AvisoModal() {
  const { user, setUser } = useAuth();

  if (!user || user.debeCambiarPassword) return null; // no mostrar encima del cambio obligatorio
  if (!ROLES_GESTORES.includes(user.role)) return null;
  if ((user.ultimoAvisoVisto || 0) >= AVISO_VERSION) return null;

  const handleClose = async () => {
    try {
      await api.patch('/auth/me/marcar-aviso-visto', { version: AVISO_VERSION });
      setUser({ ...user, ultimoAvisoVisto: AVISO_VERSION });
    } catch {
      // si falla, no bloqueamos al usuario, solo no se actualiza el flag
      setUser({ ...user, ultimoAvisoVisto: AVISO_VERSION });
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400, padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 28, width: '100%', maxWidth: 440, boxShadow: '0 8px 40px rgba(0,0,0,0.25)' }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>📬</div>
        <h2 style={{ margin: '0 0 10px', fontSize: 18, fontWeight: 700, color: '#1a2f6b' }}>Novedad: Resumen diario de pendientes</h2>
        <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.6, margin: '0 0 12px' }}>
          Ahora, en lugar de recibir varios correos al día sobre solicitudes vencidas, recibirás <strong>un solo correo resumen cada mañana a las 8:00am</strong> con todo lo pendiente.
        </p>
        <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.6, margin: '0 0 20px' }}>
          Ese resumen incluye tus <strong>solicitudes vencidas</strong> y tus <strong>actividades pendientes o atrasadas</strong>, todo en un solo lugar. Si no tienes nada pendiente ese día, simplemente no recibirás correo.
        </p>
        <button onClick={handleClose}
          style={{ width: '100%', padding: '11px', border: 'none', borderRadius: 10, background: '#2563eb', color: 'white', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
          Entendido
        </button>
      </div>
    </div>
  );
}